import React from 'react';
import { ColumnDef } from '@tanstack/react-table';
import moment from 'moment';
import { IconButton } from 'src/domains/common/components/button/icon-button';
import { DateTime } from 'src_common/utils/time/time';
import { SuccessResponseType } from 'src_server/types/paymentSearch/paymentsSearchTypes';

type RowType = SuccessResponseType['results'][number];

const openBankingDetails = (row: RowType): string => {
    return row.paymentDetails.name ?? '';
};

const cardDetails = (row: RowType): string => {
    const expires = row.paymentDetails.expires;

    if (expires === undefined || expires === null) {
        return row.paymentType;
    }

    const formatedExpires = DateTime.from(expires)?.format('MM/YY');
    return `${row.paymentType}, ${formatedExpires}`;
};

export const formatDetails = (row: RowType): string => {
    if (row.paymentDetails.type === 'open-banking') {
        return openBankingDetails(row);
    }

    return cardDetails(row);
};

export const columns: ColumnDef<RowType>[] = [
    {
        id: 'expand',
        size: 60,
        minSize: 60,
        maxSize: 60,
        cell: ({ row }) => (
            <IconButton
                variant='ghost'
                icon={row.getIsExpanded() ? 'minus' : 'plus'}
                onClick={() => row.toggleExpanded()}
            />
        ),
    },
    {
        cell: ({ row }) => (row.original.time === null ? null : moment(row.original.time).format('DD/MM/YYYY HH:mm')),
        header: 'Date & Time',
        size: 140,
        minSize: 140,
    },
    {
        accessorKey: 'id',
        header: 'Transaction No.',
        size: 120,
        minSize: 120,
    },
    {
        cell: ({ row }) => row.original['account.id'],
        header: 'Account ID',
        size: 100,
        minSize: 100,
    },
    {
        accessorKey: 'customerName',
        header: 'Customer Name',
        size: 150,
        minSize: 150,
    },
    {
        cell: ({ row }) => <span className='capitalize'>{row.original.transactionType}</span>,
        header: 'Transaction Type',
        size: 130,
        minSize: 130,
    },
    {
        cell: ({ row }) => <span className='capitalize'>{formatDetails(row.original)}</span>,
        header: 'Details',
        size: 200,
        minSize: 200,
    },
    {
        accessorKey: 'currency',
        header: 'Currency',
        size: 80,
        minSize: 80,
    },
    {
        cell: ({ row }) => <span className='capitalize'>{row.original.status}</span>,
        header: 'Status',
        size: 100,
        minSize: 100,
    },
    {
        accessorKey: 'amount',
        header: 'Amount',
        size: 100,
        minSize: 100,
    },
    {
        accessorKey: 'playableBalanceAfter',
        header: 'Playable Balance',
        size: 140,
        minSize: 140,
    },
    {
        accessorKey: 'withdrawableBalanceAfter',
        header: 'Withdrawable Balance',
        size: 160,
        minSize: 160,
    },
    {
        accessorKey: 'failedWithdrawalsFundsAfter',
        header: 'Failed Withdrawals Funds',
        size: 200,
        minSize: 200,
    },
];
